import type { CartItem } from '@/stores/cart'
import fetch from './lib/fetch'

export type CheckoutCharge = {
  id?: number
  external_order_id?: { ecommerce: string | null }
  error?: string
}

export async function checkout(
  rechargeId: string,
  addressId: string,
  cartItems: CartItem[],
): Promise<CheckoutCharge> {
  const cartItemsWithRechargeSellingPlans = await Promise.all(
    cartItems.map(async (item) => ({
      ...item,
      discount: item.discount,
    })),
  )

  const charge: CheckoutCharge = await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/protected/subscriptions/${rechargeId}/cart/checkout`,
    {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        addressId,
        cartItems: cartItemsWithRechargeSellingPlans,
      }),
    },
  )

  if (!charge?.external_order_id) {
    throw new Error(
      charge?.error
        ? `Checkout failed: ${charge.error}`
        : 'Checkout succeeded but response missing external_order_id',
    )
  }

  return charge
}
